import { createSlice } from '@reduxjs/toolkit'

const acknowledgementModalSlice = createSlice({
  name: 'acknowledgementModal',
  initialState: {
    showModal: false,
  },
  reducers: {
    closeAcknowledgementModal: (state) => {
      state.showModal = false
    },
    clearAcknowledgementModal: (state) => {
      state.showModal = false
      state.type = null
    },
    showAcknowledgementModal: (state, { payload }) => {
      state.showModal = true
      state.type = payload
    },
  },
})

export const {
  reducer,
  actions: {
    closeAcknowledgementModal,
    clearAcknowledgementModal,
    showAcknowledgementModal,
  },
} = acknowledgementModalSlice
